import { render, staticRenderFns } from "./NewSalary.vue?vue&type=template&id=8184b982&scoped=true"
import script from "./NewSalary.vue?vue&type=script&lang=js"
export * from "./NewSalary.vue?vue&type=script&lang=js"
import style0 from "./NewSalary.vue?vue&type=style&index=0&id=8184b982&prod&lang=css"
import style1 from "./NewSalary.vue?vue&type=style&index=1&id=8184b982&prod&scoped=true&lang=css"
import style2 from "../../constant/css/detail.css?vue&type=style&index=2&id=8184b982&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8184b982",
  null
  
)

export default component.exports